import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io"
import { error } from "./notifications"
import tinycolor from "tinycolor2";
import moment from "moment";
import 'moment/locale/es';

export const catchResponse = (err:any) => {
    if('response' in err) {
        const { detail } = err.response.data
        error(detail)
    } else {
        error("Error obteniendo la información")
    }
    
}

export const numberFormatter = (number:number) => {
   
    // Redondeamos el número a dos decimales
    const numeroRedondeado = Number(isNaN(number)? 0 : number).toFixed(2);

    // Dividimos el número en parte entera y decimal
    const partes = numeroRedondeado.toString().split('.');
    if(partes) {
        const parteEntera = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Agregamos puntos para los miles
        const parteDecimal = partes[1] !== '00' ? ',' + partes[1] : ''; // Agregamos coma para los decimales si son distintos de '00'
    
        return parteEntera + parteDecimal;
    }

    return number
    
    
}

export const dateFormatter = (date:any) => {
    
    if(date === "" || date === undefined) {
        return ""
    } else {
        let m = date.getMonth() + 1
        let y = date.getFullYear().toString().substring(-2)
        let formatted_date = `${("0" + m).slice(-2)}/${y}`
        return formatted_date
    }
    
}

export const dateFullFormatter = (date:any) => {
    if(date === "" || date === undefined) {
        return ""
    } else {
        const day = date.getDate();
        const month = date.getMonth() + 1; // Los meses en JavaScript son base 0, por lo que se suma 1
        const year = date.getFullYear();
        const formattedDay = day < 10 ? `0${day}` : day;
        const formattedMonth = month < 10 ? `0${month}` : month;
        return `${formattedDay}/${formattedMonth}/${year}`
    }
}

const whoareyou = (who_are_you:any) => {
    return who_are_you.filter((item:any,index:number) => {
        if(index < who_are_you.length - 1 ) {
            return true
        }
        return false
    }).join("_")
}

export const diferencialPercentRenderer = (params:any) => {
    const { colId } = params.column
    let who_are_you = colId.split("_")
    let comparative;
    who_are_you.slice(-1)[0] === 'a'? comparative = 'b' : comparative = 'a'

   let final_value = whoareyou(who_are_you)

    final_value = `${final_value}_${comparative}`

    if(params.value < params.data[final_value]) {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} %</span><IoMdArrowDropdown style={{marginLeft:'0.25rem',color:'red',minWidth:20}} size={16} /></span>
    } else if(params.value > params.data[final_value]) {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} %</span><IoMdArrowDropup style={{marginLeft:'0.25rem',color:'green',minWidth:20}} size={16} /></span>
    } else {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} %</span><span style={{marginLeft:'0.25rem',color:'gray'}}>-</span></span>

    }


}

export const percentRenderer = (params:any) => {
    return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} %</span></span>
}

export const diferencialKmRenderer = (params:any) => {
    const { colId } = params.column
    let who_are_you = colId.split("_")
    let comparative;
    who_are_you.slice(-1)[0] === 'a'? comparative = 'b' : comparative = 'a'

    let final_value = whoareyou(who_are_you)

    final_value = `${final_value}_${comparative}`

    if(params.value < params.data[final_value]) {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} km</span><IoMdArrowDropdown style={{marginLeft:'0.25rem',color:'red',minWidth:20}} size={16} /></span>
    } else if(params.value > params.data[final_value]) {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} km</span><IoMdArrowDropup style={{marginLeft:'0.25rem',color:'green',minWidth:20}} size={16} /></span>
    } else {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} km</span><span style={{marginLeft:'0.25rem',color:'gray'}}>-</span></span>

    }


}

export const kmRenderer = (params:any) => {
    return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} km</span></span>
}

export const tmRenderer = (params:any) => {
    return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} Tm</span></span>
}

export const diferencialDefaultRenderer = (params:any) => {
    const { colId } = params.column
    let who_are_you = colId.split("_")
    let comparative;
    who_are_you.slice(-1)[0] === 'a'? comparative = 'b' : comparative = 'a'

    let final_value = whoareyou(who_are_you)

    final_value = `${final_value}_${comparative}`

    if(params.value < params.data[final_value]) {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)}</span><IoMdArrowDropdown style={{marginLeft:'0.25rem',color:'red',minWidth:20}} size={16} /></span>
    } else if(params.value > params.data[final_value]) {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)}</span><IoMdArrowDropup style={{marginLeft:'0.25rem',color:'green',minWidth:20}} size={16} /></span>
    } else {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)}</span><span style={{marginLeft:'0.25rem',color:'gray'}}>-</span></span>

    }


}

export const defaultRenderer = (params:any) => {
    return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)}</span></span>
}

export const diferencialKgRenderer = (params:any) => {
    const { colId } = params.column
    let who_are_you = colId.split("_")
    let comparative;
    who_are_you.slice(-1)[0] === 'a'? comparative = 'b' : comparative = 'a'

    let final_value = whoareyou(who_are_you)

    final_value = `${final_value}_${comparative}`

    if(params.value < params.data[final_value]) {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} kg</span><IoMdArrowDropdown style={{marginLeft:'0.25rem',color:'red',minWidth:20}} size={16} /></span>
    } else if(params.value > params.data[final_value]) {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} kg</span><IoMdArrowDropup style={{marginLeft:'0.25rem',color:'green',minWidth:20}} size={16} /></span>
    } else {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} kg</span><span style={{marginLeft:'0.25rem',color:'gray'}}>-</span></span>

    }


}

export const kgRenderer = (params:any) => {
    return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} kg</span></span>
}

export const diferencialEuroRenderer = (params:any) => {
    const { colId } = params.column
    let who_are_you = colId.split("_")
    let comparative;
    who_are_you.slice(-1)[0] === 'a'? comparative = 'b' : comparative = 'a'

    let final_value = whoareyou(who_are_you)

    final_value = `${final_value}_${comparative}`

    if(params.value < params.data[final_value]) {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} €</span><IoMdArrowDropdown style={{marginLeft:'0.25rem',color:'red',minWidth:20}} size={16} /></span>
    } else if(params.value > params.data[final_value]) {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} €</span><IoMdArrowDropup style={{marginLeft:'0.25rem',color:'green',minWidth:20}} size={16} /></span>
    } else {
        return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} €</span><span style={{marginLeft:'0.25rem',color:'gray'}}>-</span></span>

    }


}

export const euroRenderer = (params:any) => {
    return <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><span style={{minWidth:30}}>{numberFormatter(params.value)} €</span></span> 
}


export const getRandomHexColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

export const generateUserColor = (userId:string) => {
    // Convertir el id_usuario en un valor numérico
    const numericValue = userId
    .split("-")
    .map((char) => char.charCodeAt(0))
    .reduce((acc, value) => acc + value, 0);

    // Crear un color único basado en el valor numérico
    const color = tinycolor({ h: numericValue % 360, s: 90, l: 70 });

    // Devolver el color en formato CSS
    return color.toHexString();
}

export const getWeekNumber = (date:any) => {
    const d:any = new Date(date);
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    const yearStart:any = new Date(d.getFullYear(), 0, 1);
    const weekNumber = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    return weekNumber;
}

export const getWeekNumberMoment = (fechaString:string) => {
    
  // Parsea la fecha en formato DD/MM/YYYY usando moment
  const fecha = moment(fechaString, 'DD/MM/YYYY', true);

  // Verifica si la fecha es válida
  if (!fecha.isValid()) {
    return 'Fecha no válida';
  }

  // Ajusta para considerar que la semana comienza el lunes
  const numeroSemana = fecha.isoWeek() + (fecha.isoWeekday() === 7 ? 1 : 0);

  return numeroSemana;
}

export const isNanParseFloatTreatment = (number:any) => {
    
    return isNaN(number) ? 0 : parseFloat(number)
}

export const getMonthInterval = (month_from:any, month_to:any) => {
    // Parsear las fechas de entrada
    const [fromMonth, fromYear] = month_from.split('/');
    const [toMonth, toYear] = month_to.split('/');
  
    // Crear fechas de inicio y fin
    const startDate = new Date(`${fromYear}-${fromMonth}-01`);
    const endDate = new Date(`${toYear}-${toMonth}-01`);
  
    // Array para almacenar los nombres de los meses
    const monthNames = [
      'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
    ];
  
    // Función para obtener el nombre del mes y año en el formato deseado
    const getFormattedMonth = (date:any) => {
      const month = date.getMonth();
      const year = date.getFullYear().toString().substr(-2);
      return `${monthNames[month]} ${year}`;
    };
  
    // Generar el intervalo de meses
    const interval = [];
    let currentDate = startDate;
    while (currentDate <= endDate) {
      interval.push(getFormattedMonth(currentDate));
      currentDate.setMonth(currentDate.getMonth() + 1);
    }
  
    // Añadir el último mes al intervalo si es diferente al mes inicial
    if (interval[interval.length - 1] !== getFormattedMonth(endDate)) {
      interval.push(getFormattedMonth(endDate));
    }
  
    return interval;
}

export const getMonthYearFromDate = (date:any) => {
    const meses = [
        'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ];
    
      const [dia, mes, anio] = date.split('/');
    
      const mesAbreviado = meses[parseInt(mes, 10) - 1];
      const anioAbreviado = anio.slice(2);
    
      return `${mesAbreviado} ${anioAbreviado}`;
}

export const isBefore = (date1:any,date2:any) => {
    const meses = [
        'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ];
      if(!date1 || ! date2) {
        return false
      } else {
        
        const [mesAbreviado1, anio1] = date1?.split(' ');
        const [mesAbreviado2, anio2] = date2?.split(' ');
        
        const mesNumero1 = meses.findIndex(mes => mes === mesAbreviado1);
        const mesNumero2 = meses.findIndex(mes => mes === mesAbreviado2);
      
        if (anio1 === anio2) {
          return mesNumero1 < mesNumero2;
        } else {
          return anio1 < anio2;
        }
      }
      
}

export const isSame = (date1:any,date2:any) => {
    const meses = [
        'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ];
      if(!date1 || ! date2) {
        return false
      } else {
        
        const [mesAbreviado1, anio1] = date1?.split(' ');
        const [mesAbreviado2, anio2] = date2?.split(' ');
        
        const mesNumero1 = meses.findIndex(mes => mes === mesAbreviado1);
        const mesNumero2 = meses.findIndex(mes => mes === mesAbreviado2);
      
        if (anio1 === anio2) {
          return mesNumero1 === mesNumero2;
        } else {
          return anio1 === anio2;
        }
      }
      
}

export const getRangeReal = (date:string) => {
   
    // Parsea la fecha de entrada
    const fecha = moment(date, 'DD/MM/YYYY');

    if (!fecha.isValid()) {
    return 'Fecha no válida';
    }

    // Obtiene el primer día del mes (Real)
    const primerDiaDelMes = moment(fecha).startOf('month');

    // Obtiene el último día del mes (Planificado)

    // Construye el string final
    const realFormatted = `Real (${primerDiaDelMes.format('DD/MM/YYYY')} -> ${fecha.subtract(1, 'days').format('DD/MM/YYYY')})`;

    return `${realFormatted}`;
}

export const getRangePlanificated = (date:string) => {
  
    // Parsea la fecha de entrada
    const fecha = moment(date, 'DD/MM/YYYY');

    if (!fecha.isValid()) {
    return 'Fecha no válida';
    }

    // Obtiene el primer día del mes (Real)

    // Obtiene el último día del mes (Planificado)
    const ultimoDiaDelMes = moment(fecha).endOf('month');

    // Construye el string final
    const planificadoFormatted = `Planificado (${fecha.add(1, 'days').format('DD/MM/YYYY')} -> ${ultimoDiaDelMes.format('DD/MM/YYYY')})`;

    return `${planificadoFormatted}`;
}

// Función para obtener el mes y año a partir de la semana y año dados
export const weekYearParser = (semana:any, anio:any) => {
    if( ! (semana && anio)) {
        return 'null'
    } else {
        // Crear un objeto moment con la semana y el año dados
        let fecha = moment().year(anio).isoWeek(semana).startOf('isoWeek');


        // Verificar si la semana pertenece al año indicado
        if (fecha.isoWeekYear() !== anio) {
            // Si la semana pertenece al siguiente año
            fecha = fecha.add(1, 'year');
        }
                
        // Obtener el mes y año correspondientes
        let mes = fecha.format('MMMM');
        mes = mes.charAt(0).toUpperCase() + mes.slice(1);

        let anioResultado = fecha.year();

        return `${mes} ${anioResultado}`
    }
    
    
  }